import { webchatClasses } from '../../../styles/classes'
import { AudioBlock, type CommonBlockProps } from '../../../types'

type Props = AudioBlock & CommonBlockProps
export const Audio = ({ ref, url, isReadOnly, ...props }: Props) => {
  const {
    message: {
      blocks: { audio },
    },
  } = webchatClasses
  return (
    <div>
      <audio
        {...props}
        controls
        style={isReadOnly ? { pointerEvents: 'none' } : undefined}
        src={url}
        {...audio}
        ref={ref}
      />
    </div>
  )
}

Audio.displayName = 'Audio'
